export const GlobalVars = {
    whiteMain: '#f1f1f1',
    blackMain: '#080800',
    pinkMain: '#FA1D4D',
    yellowMain: '#fcee09',
    blueMain: '#2cb2f3',

    whiteSecondary: '#e6e5e7',
    blackSecondary: '#111',

    whiteTertiary: '#dcdcdc',
    blackTertiary: '#252525',

    redTint: '#ff151529',
    yellowTint: '#fffa1526',

    greenMain: '#21fb5c',
    transparent: 'transparent',
    alert: '#fcee09',
    error: '#FA1D4D',
    success: '#21fb5c',
}